var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContentUsageActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_976_9251",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_976_9251)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0598 7.29788C16.2639 7.29688 16.4675 7.27729 16.668 7.23935V13.8833C16.668 16.6784 15.0192 18.332 12.22 18.332H6.12327C3.31673 18.332 1.66797 16.6784 1.66797 13.8833V7.79545C1.66797 5.00032 3.31673 3.33203 6.12327 3.33203H12.7622C12.7229 3.53453 12.7032 3.74037 12.7036 3.94666C12.7036 5.79749 14.2062 7.29788 16.0598 7.29788ZM13.3411 9.33937V9.3247C13.5451 9.05078 13.4931 8.66445 13.2239 8.45395C13.0936 8.35345 12.9281 8.30991 12.7652 8.33336C12.6022 8.35678 12.4557 8.4452 12.3592 8.57836L10.3514 11.1613L8.06514 9.36128C7.93461 9.25961 7.76856 9.2147 7.60448 9.2367C7.44039 9.25878 7.29212 9.34586 7.19313 9.47836L4.73099 12.6539C4.64444 12.7619 4.59785 12.8963 4.59909 13.0344C4.5848 13.3138 4.76119 13.5675 5.02829 13.6519C5.29537 13.7362 5.58579 13.6298 5.73489 13.393L7.79401 10.7296L10.0803 12.5223C10.2103 12.6271 10.3775 12.6746 10.5433 12.6539C10.7091 12.6333 10.8594 12.5461 10.9596 12.4125L13.3411 9.33937Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.3346 3.7513C18.3346 2.60071 17.4019 1.66797 16.2513 1.66797C15.1007 1.66797 14.168 2.60071 14.168 3.7513C14.168 4.90189 15.1007 5.83463 16.2513 5.83463C17.4019 5.83463 18.3346 4.90189 18.3346 3.7513Z",
    fill: "#2D2D2D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentUsageActive);
export default __webpack_public_path__ + "static/media/contentUsageActive.acb650d1db600a683f483a73163138ae.svg";
export { ForwardRef as ReactComponent };